import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ai-tools-panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "ai-icon header-icon",
  id: "aiToolsIcon"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-microchip-ai" })
], -1)

import { ref } from "vue";
import DxContextMenu, { DxPosition } from "devextreme-vue/context-menu";
import { PropertyFindResult } from "@/types/find/properties/PropertyFindResult";
import AiTextGeneratorModal from "@/components/ai/ai-text-generator-modal.vue";
import FindPropertyModal from "@/components/find/properties/find-property-modal.vue";
import AiPropertyListingWizard from "@/components/properties/ai-property-listing-wizard.vue";
import AiPictureSelectModal from "@/components/ai/ai-picture-select-modal.vue";
import displayErrorMessage from "@/utils/ErrorHandling";


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-panel',
  setup(__props) {

const currentSelectedProperty = ref<PropertyFindResult>();

// There are separate find property modals to allow us to route more easily to the stage after selecting the property
const displayFindPropertyModalForEnhance = ref(false);
const displayFindPropertyModalForListing = ref(false);
const displayPictureSelectModal = ref(false);
const displayTextGeneratorModal = ref(false);
const displayPropertyListingModal = ref(false);

const aiMenuItems = [
  {
    text: "AI Property Listing",
    icon: "fas fa-home",
    onClick: onAiPropertyListingClick,
  },
  {
    text: "AI Image Enhancement",
    icon: "fas fa-image",
    onClick: onAiImageEnhanceClick,
  },
  {
    text: "AI Text Generator",
    icon: "fas fa-file-alt",
    onClick: onAiTextClick,
  },
];

function onAiPropertyListingClick() {
  displayFindPropertyModalForListing.value = true;
}

function onAiImageEnhanceClick() {
  displayFindPropertyModalForEnhance.value = true;
}

function onAiTextClick() {
  displayTextGeneratorModal.value = true;
}

const onItemClick = (e: any) => {
  e?.itemData?.onClick?.();
};

const setPropertyForListing = (
  selectedProperty: PropertyFindResult | undefined,
) => {
  if (selectedProperty) {
    currentSelectedProperty.value = selectedProperty;
    displayPropertyListingModal.value = true;
  }
};

const setPropertyForEnhance = (
  selectedProperty: PropertyFindResult | undefined,
) => {
  if (selectedProperty) {
    currentSelectedProperty.value = selectedProperty;
    displayPictureSelectModal.value = true;
  }
};

const noPropertyImagesAvailable = () => {
  displayFindPropertyModalForEnhance.value = true;
  displayErrorMessage("Selected property has no images.");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(DxContextMenu), {
      target: "#aiToolsIcon",
      items: aiMenuItems,
      width: 220,
      "show-event": "dxclick",
      "css-class": "ai-menu",
      onItemClick: onItemClick
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DxPosition), {
          my: "top center",
          at: "bottom center"
        })
      ]),
      _: 1
    }),
    _createVNode(AiTextGeneratorModal, {
      modelValue: displayTextGeneratorModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayTextGeneratorModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(FindPropertyModal, {
      modelValue: displayFindPropertyModalForListing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayFindPropertyModalForListing).value = $event)),
      onPropertySelected: setPropertyForListing,
      title: "Select Property to List"
    }, null, 8, ["modelValue"]),
    _createVNode(FindPropertyModal, {
      modelValue: displayFindPropertyModalForEnhance.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((displayFindPropertyModalForEnhance).value = $event)),
      onPropertySelected: setPropertyForEnhance,
      title: "Select Property to Enhance"
    }, null, 8, ["modelValue"]),
    _createVNode(AiPictureSelectModal, {
      "show-modal": displayPictureSelectModal.value,
      "onUpdate:showModal": _cache[3] || (_cache[3] = ($event: any) => ((displayPictureSelectModal).value = $event)),
      "property-id": currentSelectedProperty.value?.id ?? -1,
      onNoImagesAvailable: noPropertyImagesAvailable
    }, null, 8, ["show-modal", "property-id"]),
    _createVNode(AiPropertyListingWizard, {
      modelValue: displayPropertyListingModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((displayPropertyListingModal).value = $event)),
      "property-id": currentSelectedProperty.value?.id ?? -1
    }, null, 8, ["modelValue", "property-id"])
  ]))
}
}

})